import { RegistryItem } from "@schemas/calculationmethods/schema";
import { CalculationMethodType } from "__generated__/graphql";

export const CoveredByFreightPriceSchema: RegistryItem = {
	[CalculationMethodType.CoveredByFreightPrice]: {
		toInput: (form) => ({
			coveredByFreightPriceCalculationMethodInput: {
				id: form.id ?? undefined,
			},
		}),
	},
};
